module.exports = __webpack_public_path__ + "static/IWD-full-522852d0e08c1588607d6773ce820359.png";